import type { FC } from 'react';
import React from 'react';

import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

const DividerStyles = xcss({
	width: 'calc(100% - 12px)',
	minHeight: token('space.025'),
	marginBlock: 'space.500',
	marginInline: 'space.075',
	background: token('color.border'),
	borderRadius: 'border.radius.100',
});

export const Divider: FC = () => <Box xcss={DividerStyles} />;
